import React, { useState } from "react";
import { usePWAInstall } from "../../context/PWAInstallContext";

export default function PWAInstallBanner() {
  const {
    shouldShowBanner,
    isIOS,
    deferredPrompt,
    dismiss,
    triggerInstall,
  } = usePWAInstall();

  const [showIOSGuide, setShowIOSGuide] = useState(false);

  if (!shouldShowBanner) return null;

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      // Android / Chrome — native prompt available
      await triggerInstall();
    } else if (isIOS) {
      // iOS — no native prompt, show manual instructions
      setShowIOSGuide(true);
    } else {
      // Fallback — browser doesn't support native prompt
      setShowIOSGuide(true);
    }
  };

  return (
    <>
      <div className="pwa-install-banner">
        <div className="pwa-install-banner-content">
          <i className="fa-solid fa-mobile-screen-button pwa-install-banner-icon" />
          <span className="pwa-install-banner-text">
            Install app for a better experience
          </span>
        </div>

        <div className="pwa-install-banner-actions">
          <button
            type="button"
            className="pwa-install-banner-btn"
            onClick={handleInstallClick}
          >
            Install
          </button>
          <button
            type="button"
            className="pwa-install-banner-dismiss"
            onClick={dismiss}
            aria-label="Dismiss install banner"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
      </div>

      {/* iOS / fallback manual install instructions */}
      {showIOSGuide && (
        <div
          className="pwa-install-guide-overlay"
          onClick={() => setShowIOSGuide(false)}
        >
          <div
            className="pwa-install-guide"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pwa-install-guide-header">
              <h3>Install GradeMe AI</h3>
              <button
                type="button"
                className="pwa-install-guide-close"
                onClick={() => setShowIOSGuide(false)}
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>

            <div className="pwa-install-guide-body">
              {isIOS ? (
                <>
                  <p className="pwa-install-guide-subtitle">
                    To install on your iPhone or iPad:
                  </p>
                  <ol>
                    <li>
                      Tap the <strong>Share</strong> button{" "}
                      <i className="fa-solid fa-arrow-up-from-bracket" style={{ fontSize: "0.85em" }} />{" "}
                      in Safari's toolbar
                    </li>
                    <li>
                      Scroll down and tap{" "}
                      <strong>Add to Home Screen</strong>
                    </li>
                    <li>
                      Tap <strong>Add</strong> in the top right
                    </li>
                  </ol>
                </>
              ) : (
                <>
                  <p className="pwa-install-guide-subtitle">
                    To install on your device:
                  </p>
                  <ol>
                    <li>
                      Open the browser menu{" "}
                      <i className="fa-solid fa-ellipsis-vertical" style={{ fontSize: "0.85em" }} />
                    </li>
                    <li>
                      Tap <strong>Add to Home screen</strong> or{" "}
                      <strong>Install app</strong>
                    </li>
                    <li>
                      Confirm by tapping <strong>Install</strong> or{" "}
                      <strong>Add</strong>
                    </li>
                  </ol>
                </>
              )}

              <div className="pwa-install-guide-note">
                <i className="fa-solid fa-circle-info" />
                <span>
                  Installing ensures reliable notifications and a faster,
                  app-like experience.
                </span>
              </div>
            </div>

            <div className="pwa-install-guide-footer">
              <button
                type="button"
                className="pwa-install-guide-ok"
                onClick={() => {
                  setShowIOSGuide(false);
                  dismiss();
                }}
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
